import openErrorModal from "../Error/ErrorModal";
import { openBackendValidationErrorModal } from "../Error/ErrorUtilities";
import { createService, fetchCreateServiceModal } from "../HTTPRequests/ServiceRequests";
import Mediator from "../Utilities/Mediator";
import ServiceBaseModal from "./ServiceBaseModal";

export default class CreateServiceModal extends ServiceBaseModal {
	modalDiv: HTMLDivElement;
	createButton: HTMLButtonElement;
	isSimpleItem: boolean;
	priceSection: HTMLDivElement;

	constructor(createStoreButton: HTMLButtonElement) {
		super();
		this.modalDiv = document.createElement('div');
		this.createButton = createStoreButton;
	}

	public addCreateModalClickListener() {
		this.createButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchCreateServiceModal();
		}
	}

	private fetchCreateServiceModal() {
		fetchCreateServiceModal()
			.then((response: string) => {
				this.openCreateModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openCreateModal(modalHTMLString: string) {
		this.modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(this.modalDiv);

		this.addUploadImageChangeEventListener();
		this.addModalButtonsClickListeners();
		this.addDescriptionModalEventsListeners(this.modalDiv);
		this.addItemSelectChangeListener();
	}

	private addModalButtonsClickListeners() {
		const cancelButton: HTMLButtonElement = document.querySelector('#create-service-modal button');
		cancelButton.onclick = () => {
			this.modalDiv.remove();
		};

		const img: HTMLImageElement = document.querySelector('#create-service-modal img[alt="close icon"]');
		img.onclick = () => {
			this.modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#create-service-modal button:last-child');
		saveButton.onclick = () => {
			this.saveCreatedService();
		}
	}

	private addItemSelectChangeListener() {
		const itemsSelect: HTMLSelectElement = this.modalDiv.querySelector('select[name="items"]');
		this.priceSection = this.modalDiv.querySelector(".service-cost");

		itemsSelect.onchange = () => {
			this.isSimpleItem = Array.from(itemsSelect.selectedOptions).some(o => o.selected && o.dataset.simple);
			this.priceSection.style.display = this.isSimpleItem ? "block" : "none";
			if (this.isSimpleItem) {
				this.addInputNumberEventsListeners("#create-service-modal");
			}
		}
	}

	private saveCreatedService() {
		if (!this.isSimpleItem) {
			this.priceSection.remove();
		}

		let { valid, serviceFormData } = this.getModalData(this.isSimpleItem);
		if (valid) {
			document.body.append(this.loadingScreen);
			this.createService(serviceFormData);
		} else {
			this.form.reportValidity();
		}
	}

	private createService(serviceFormData: FormData) {
		const select: HTMLSelectElement = document.querySelector("#service-modal select");

		createService(select.value, serviceFormData)
			.then(() => {
				this.modalDiv.remove();
				Mediator.emit("serviceCrudOperationFinished");
			}, (error) => { //backend error
				openBackendValidationErrorModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
